export const TranslationIdMap = '';

export const TranslationKeyMap = {
    '_11041_CHAT': 'Chat',
    '_11164_CONVERSATIONS_ACTIVE': 'Conversations Active',
    '_11159_ENTER_A_NAME_TO_SEARCH': 'Enter a name to search',
    '_11171_YESTERDAY': 'Yesterday'
};
